import { Acao, Condicao } from '../../../types/regraApiType'
import { GrupoRegra, GrupoRegraCadastro, PriorizacaoRegras, RegraTransformacao, RegraTransformacaoForm } from '../../../types/transformacaoApiTypes'
import transformacaoApiService from './transformacaoApiService'

const buscarCondicoes = async (): Promise<Condicao[]> => transformacaoApiService.buscarCondicoes()

const buscarAcoes = async (): Promise<Acao[]> => transformacaoApiService.buscarAcoes()

const cadastrarRegra = async (body: RegraTransformacaoForm, parceiroId?: string | number): Promise<string> =>
  transformacaoApiService.cadastrarRegra(body, parceiroId)

const editarRegra = async (body: RegraTransformacaoForm, parceiroId?: string | number, regraId?: string | number): Promise<string> =>
  transformacaoApiService.editarRegra(body, parceiroId, regraId)

const aplicarTransformacao = async (parceiroId: number, arquivoId: string): Promise<string> =>
  transformacaoApiService.aplicarTransformacao(parceiroId, arquivoId)

const buscarRegras = async (parceiroId?: string | number): Promise<RegraTransformacao[]> => transformacaoApiService.buscarRegras(parceiroId)

const buscarRegra = async (parceiroId?: string | number, regraId?: string | number): Promise<RegraTransformacao> =>
  transformacaoApiService.buscarRegra(parceiroId, regraId)

const enviarArquivo = async (body: string[]): Promise<string> => transformacaoApiService.enviarArquivo(body)

const transformarPlanilha = async (cicloId: string): Promise<string> => transformacaoApiService.transformarPlanilha(cicloId)

const tratarPlanilha = async (cicloId: string, numerosLinhas: number[] | string[], tipoTratamento: string): Promise<string> =>
  transformacaoApiService.tratarPlanilha(cicloId, numerosLinhas, tipoTratamento)

const cadastrarGrupoRegra = async (body: GrupoRegraCadastro, parceiroId: string | number) => transformacaoApiService.cadastrarGrupoRegra(body, parceiroId)

const editarGrupoRegra = async (body: GrupoRegra, parceiroId: string | number) => transformacaoApiService.editarGrupoRegra(body, parceiroId)

const buscarGruposRegras = async (parceiroId: string | number): Promise<GrupoRegra[]> => transformacaoApiService.buscarGruposRegras(parceiroId)

const editarTabelaErroProcessamento = async (
  cicloId: string,
  itemLancamento: string[],
  indexEditado: number
): Promise<{ cicloId: string; itemLancamento: string[]; indexEditado: number }> =>
  transformacaoApiService.editarTabelaErroProcessamento(cicloId, itemLancamento, indexEditado)

const reordenarPrioridade = async (parceiroId: string | number, body: PriorizacaoRegras[]): Promise<boolean> =>
  transformacaoApiService.reordenarPrioridade(parceiroId, body)

export default {
  buscarCondicoes,
  buscarAcoes,
  cadastrarRegra,
  editarRegra,
  aplicarTransformacao,
  buscarRegras,
  enviarArquivo,
  transformarPlanilha,
  tratarPlanilha,
  cadastrarGrupoRegra,
  editarGrupoRegra,
  buscarGruposRegras,
  editarTabelaErroProcessamento,
  reordenarPrioridade,
  buscarRegra
}
